var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.504 16.764a7.13 7.13 0 1 1 1.26-1.26l2.975 2.974a.891.891 0 0 1-1.26 1.26zm.975-5.633a5.348 5.348 0 1 1-10.696 0 5.348 5.348 0 0 1 10.696 0",
    clipRule: "evenodd"
  })));
};
export { SvgSearch as ReactComponent };